




























import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Thumbnail from '@/components/dashboard/thumbnail/Thumbnail.vue';
import Table from '@/components/dashboard/table/Table.vue';

@Component({
  components: { Table, Thumbnail },
})
export default class Dashboard extends Vue {
  activeTitle = 'Lignes actives créées';

  inactiveTitle = 'Lignes mortes';

  accountSelectedValue: any = {
    month: null,
    year: null,
  };

  queueSelectedValue: any = {
    month: null,
    year: null,
  };

  accountLength: Number = 0;

  queueLength: Number = 0;

  dateMonth: any = {
    Janvier: 'January',
    Février: 'February',
    Mars: 'March',
    Avril: 'April',
    Mai: 'May',
    Juin: 'June',
    Juillet: 'July',
    Août: 'August',
    Septembre: 'September',
    Octobre: 'October',
    Novembre: 'November',
    Décembre: 'December',
  };

  get compActiveList() {
    return this.$store.getters['queue/activeList'] || [];
  }

  get compDeadList() {
    return this.$store.getters['queue/deadList'] || [];
  }

  get compAverageChild() {
    return this.$store.getters['queue/averageChild'];
  }

  async changeAccountFilter(val: any, info: string) {
    this.updateSelected(val, info, true);

    this.accountLength = await this.changeFilter(
      this.accountSelectedValue,
      { dispatch: 'account/a_get_listSortedLength', getter: 'account/listSortedLength' },
      { dispatch: 'account/a_get_length', getter: 'account/length' },
    );
  }

  async changeQueueFilter(val: any, info: string) {
    this.updateSelected(val, info, false);

    this.queueLength = await this.changeFilter(
      this.queueSelectedValue,
      { dispatch: 'queue/a_get_listByMonthAndYearLength', getter: 'queue/listByMonthAndYearLength' },
      { dispatch: 'queue/a_get_length', getter: 'queue/length' },
    );
  }

  updateSelected(val: any, info: string, isAccount: boolean) {
    const selectedValue = isAccount ? this.accountSelectedValue : this.queueSelectedValue;
    if (info === 'month') {
      selectedValue.month = val ? this.dateMonth[val] : null;
    }
    if (info === 'year') {
      selectedValue.year = val || null;
    }
  }

  async changeFilter(selectedValue: any, routeFilter: any, routeNoFilter: any): Promise<number> {
    if (selectedValue.month !== null || selectedValue.year !== null) {
      await this.$store.dispatch(routeFilter.dispatch, { month: selectedValue.month, year: selectedValue.year });
      return this.$store.getters[routeFilter.getter];
    }
    await this.$store.dispatch(routeNoFilter.dispatch);
    return this.$store.getters[routeNoFilter.getter];
  }

  async mounted() {
    await this.$store.dispatch('account/a_init_Account', false);
    await this.$store.dispatch('queue/a_init_Queue', false);
    this.accountLength = this.$store.getters['account/length'];
    this.queueLength = this.$store.getters['queue/length'];
    console.log(this.queueLength);
  }
}
